import _get from "lodash/get";
import store from "@/store";
import {
  httpSuccessResponseLogger,
  httpErrorResponseLogger
} from "@/helpers/logger";
import { redirectToProperErrorPage } from "@/helpers/router";

export default function({ next, to, router }) {
  const id = _get(to, "params.id");

  store
    .dispatch("projectImporter/overview/getData", id)
    .then(response => {
      httpSuccessResponseLogger(response);

      return next();
    })
    .catch(error => {
      httpErrorResponseLogger(error);

      redirectToProperErrorPage(error, to, router);
    });
}
